<template>
  <div ref="viewer" style="height:600px;"></div>
</template>

<script>
// Try dynamic import to avoid build-time issues
let NGL = null;

async function loadNGL() {
  if (!NGL) {
    try {
      const nglModule = await import('ngl');
      NGL = {
        Stage: nglModule.Stage,
        Selection: nglModule.Selection,
        ColormakerRegistry: nglModule.ColormakerRegistry,
        download: nglModule.download,
        Vector2: nglModule.Vector2,
        Vector3: nglModule.Vector3,
        setDebug: nglModule.setDebug,
        MouseActions: nglModule.MouseActions,
        Shape: nglModule.Shape
      };
    } catch (error) {
      console.error('Failed to load NGL:', error);
      return false;
    }
  }
  return true;
}
let comp = {};
export default {
  props: {
    pdbUrl: {
      type: String,
      required: true
    },
    segmentSelection: {
      type: String,
      default: ''
    },
    residueSelection: {
      type: String,
      default: ''
    }
  },

  mounted() {
    this.loadStructure();
  },
  methods: {
    async loadStructure() {
      if (!this.pdbUrl) {
        console.log('No PDB URL provided');
        return;
      }

      const nglLoaded = await loadNGL();
      if (!nglLoaded) {
        console.log('Failed to load NGL library');
        return;
      }

      const stage = new NGL.Stage(this.$refs.viewer);

      stage.loadFile(this.pdbUrl, {defaultRepresentation: true, ext: 'pdb'}).then((component) => {
        comp = component;
        this.addDefaultRepresentation();
        stage.autoView();
      });

      stage.setParameters({
        backgroundColor: 'white'
      });
    },
    addDefaultRepresentation() {
      comp.removeAllRepresentations();

      comp.addRepresentation('cartoon',
          {
            // sele: '(1-1499) or (6600-9999) or (1600-1699) or (2600-2699) or (3600-3699) or (4600-4699) or (5600-5799) or (5900-5999)',
            color: '#ffffff',
            radius: 0.30
          }
      );

      //S1
      comp.addRepresentation('cartoon',
          {
            sele: '1500-1599',
            color: '#d74747',
            radius: 0.30
          }
      );
      //S2
      comp.addRepresentation('cartoon',
          {
            sele: '2500-2599',
            color: '#89d989',
            radius: 0.30
          }
      );
      //S3
      comp.addRepresentation('cartoon',
          {
            sele: '3500-3599',
            color: '#ffff72',
            radius: 0.30
          }
      );
      //S4
      comp.addRepresentation('cartoon',
          {
            sele: '4500-4599',
            color: '#6c6cff',
            radius: 0.30
          }
      );
      //S5
      comp.addRepresentation('cartoon',
          {
            sele: '5500-5599',
            color: '#ff91ff',
            radius: 0.30
          }
      );
      //P-loop
      comp.addRepresentation('cartoon',
          {
            sele: '5800-5899',
            color: "rgb(79,187,187)",
            radius: 0.30
          }
      );
      //S6
      comp.addRepresentation('cartoon',
          {
            sele: '6500-6600',
            color: '#caa8fd',
            radius: 0.30
          }
      );
    },
    createRepresentations() {
      this.addDefaultRepresentation();

      if (this.segmentSelection) {
        comp.addRepresentation('cartoon', {
          sele: this.segmentSelection,
          color: 'red',
          radius: 0.35
        });
      }

      if (this.residueSelection) {
        comp.addRepresentation('spacefill', {
          sele: this.residueSelection,
          sphereDetail: 3
        })
      }
    }
  },
  watch: {
    segmentSelection() {
      this.createRepresentations();
    },
    residueSelection() {
      this.createRepresentations();
    }
  }
}
</script>
